import React from 'react';
import Tooltip from './Tooltip';

function CheckboxInput({ customInput, data = [], action }) {
    const {
        label,
        name,
        tooltipBool,
        tooltipText
    } = customInput;

    return (
        <>
            <label htmlFor={name}>
                {label}
                {tooltipBool === true && (
                    <Tooltip text={tooltipText}></Tooltip>
                )}
            </label>
            <div className="checkbox-group">
                {data.map((item) => (
                    <div className="checkbox" key={item.id}>
                        <input
                            type="checkbox"
                            name={name}
                            checked={item.checked}
                            onChange={() => action(item.id)}
                        />
                        <label className="checkbox-label" htmlFor={name}>{item.text}</label>
                    </div>
                ))}
            </div>
        </>
    );
}

export default CheckboxInput;